import { TPromisePopupProps } from '@@types/popup';
import {
  Button,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  Image,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export default function CheckAddressValidModal({
  props,
  closePopup,
}: TPromisePopupProps<{ roadviewImage: string }>) {
  const { resolve, roadviewImage } = props;
  const { t } = useTranslation('address');
  return (
    <DrawerContent pb="40px">
      <DrawerHeader>
        <DrawerCloseButton />
      </DrawerHeader>
      <DrawerBody className="flex items-center justify-center">
        <Image
          src={roadviewImage}
          alt="check-roadview"
          objectFit="contain"
          w="full"
          h="full"
          rounded="md"
        />
      </DrawerBody>
      <DrawerFooter>
        <div className="flex flex-col gap-2 w-full">
          <p className="text-center font-bold text-16">{t('checkLocation')}</p>
          <Button onClick={() => resolve('Y')} className="success-button">
            {t('common:ok')}
          </Button>
          <button
            onClick={() => resolve('N')}
            className="underline text-primary-800"
          >
            {t('wrongLocationButton')}
          </button>
        </div>
      </DrawerFooter>
    </DrawerContent>
  );
}
